import { createContext } from "react";

export const ExpensesContext = createContext();

export const ModalOpenCloseContext = createContext();

export const ModalTypeContext = createContext();
